import './ServiceInfo.css'

export default function ServiceInfo() {
  return (
    <div className='ServiceInfo-container'>
      <div className='ServiceInfo-title-section'>
        <h2 className='ServiceInfo-title'>OUR SERVICE</h2>
      </div>
      <div className='ServiceInfo-intro-section'>
        <div className='ServiceInfo-intro-content'>
          <div className='ServiceInfo-intro-text-block'>
            <p>
              Proudly serving our community since 1987, we are honored to carry on the tradition as the new owners. Our
              goal is simple – to provide you with clean, fresh laundry and fast, friendly service you can always count
              on.
            </p>
          </div>
        </div>
      </div>

      <div className='ServiceInfo-list-section'>
        <ul className='ServiceInfo-list'>
          <li>Commercial Laundry</li>
          <li>Residential Laundry</li>
          <li>Drop-off Service</li>
          <li>Pick-up and Delivery</li>
          <li>Dry Cleaning</li>
          <li>Self-service Coin Laundry</li>
        </ul>
      </div>
    </div>
  )
}
